// extracted by mini-css-extract-plugin
module.exports = {"title":"MainPage_title__1XIA_","date":"MainPage_date__3J3Ba"};